import { ConversationParticipantTypeEnumType } from '@mark43/cad-api';

export const SEND_AS_OPTION_CATEGORIES: {
    category: string;
    entityTypes: ConversationParticipantTypeEnumType[];
}[] = [
    { category: 'User types', entityTypes: ['USER', 'UNIT', 'CALL_TAKER_STATION'] },
    { category: 'Dispatch Areas', entityTypes: ['DISPATCH_AREA', 'DISPATCH_AREA_RESPONDERS'] },
];
